import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import Loc from "../../services/localization";
import CONFIG_COMPANY from "../../services/myConfig";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            showType: 'DAY',
            enableFuture: -2,
            hideTitle: false,
            isLoading: true,
            programToken: '',
            autoOpenIfOnce: false,
            programs: [],
            expandedDescriptions: {},
            dynamicColors: {},
            defaultBgColor: 'FF1C242D'
        }
    },
    methods: {
        load: load,
        getName: getName,
        showProgram: showProgram,
        getDynamicColor: getDynamicColor,
        getConfig: getConfig,
        getDateDisplay: getDateDisplay,
        getPageBgStyle: getPageBgStyle,
        getShortDesc: getShortDesc,
        getLongDesc: getLongDesc,
        getMaxChars: getMaxChars,
        isDescriptionExpanded: isDescriptionExpanded,
        toggleDescription: toggleDescription,
    },

    beforeMount() {
        this.programToken = this.$route.query.programToken;
        if(this.$route.query.showType != null){
            this.showType = this.$route.query.showType;
        }
        if(this.$route.query.enableFuture != null){
            this.enableFuture = this.$route.query.enableFuture;
        }
        if(this.$route.query.hideTitle != null){
            this.hideTitle = this.$route.query.hideTitle;
        }
        if(this.$route.query.autoOpenIfOnce != null){
            this.autoOpenIfOnce = this.$route.query.autoOpenIfOnce;
        }
        this.getConfig()
        this.dynamicColors = session.getAppColors() || {};
        this.role = session.getRole();
        this.load()
    }
}

function getMaxChars(str, maxChars) {
    if(str == null) return ''
    // Provera da li je ulazni string duži od maksimalnog broja karaktera
    if (str.length > maxChars) {
        // Ako jeste, vraćamo prvih maxChars karaktera
        return str.substring(0, maxChars);
    } else {
        // Ako nije, vraćamo ceo ulazni string
        return str;
    }
}

function getShortDesc(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.shortDescription;
    }else if(item.enShortDescription != null && item.enShortDescription.length > 0){
        return  item.enShortDescription;
    }
    return item.shortDescription;
}

function getLongDesc(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.longDescription;
    }else if(item.enLongDescription != null && item.enLongDescription.length > 0){
        return  item.enLongDescription;
    }
    return item.longDescription;
}

function getConfig(){
    if(!session.shouldFetchConfig()) {
        // return;
    }
    AdminApiService.getCompanyConfiguration(CONFIG_COMPANY.NAME)
        .then((response) => {
            session.saveConfig(response.data)
            session.setLastFetchConfig();
            this.dynamicColors = session.getAppColors() || {};
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}


function load() {
    this.isLoading = true;
    let _self = this;
    let model = {
        type: "PERSONAL",
        active: true
    }

    AdminApiService.getPersonalProgramsUser(model)
        .then((response) => {
            _self.programs = response.data;
            if(_self.programs.length === 1 && _self.autoOpenIfOnce){
                _self.showProgram(_self.programs[0], false)
            }
            _self.isLoading = false
        })
        .catch(error => {
            swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function getDynamicColor(itemId, defaultColor){
    if(this.dynamicColors[itemId] != null){
        return 'color: #'+ this.dynamicColors[itemId];
    }
    if(defaultColor == null) return ''
    return 'color: #'+ defaultColor;
}

function resolveBgColor(raw, fallback){
    if(raw == null) return fallback;
    let value = ('' + raw).trim();
    if(value.length === 0) return fallback;
    if(value[0] === '#') value = value.substring(1);

    if(value.length === 8){
        value = value.substring(2);
    }

    if(value.length !== 6 && value.length !== 3) return fallback;
    return '#' + value;
}

function getPageBgStyle(){
    const bgRaw = this.dynamicColors != null && this.dynamicColors.BG != null ? this.dynamicColors.BG : this.defaultBgColor;
    return {
        '--personal-page-bg': resolveBgColor(bgRaw, '#1C242D')
    };
}


function getName(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.name;
    }else if(item.enName != null && item.enName.length > 0){
        return  item.enName;
    }
    return item.name;
}

function getDateDisplay(item){
    let fromDate = this.$moment(item.startTime * 1000).format('DD-MM-YYYY');
    let toDate = this.$moment(item.endTime * 1000).format('DD-MM-YYYY');
    return fromDate + " - " + toDate;
}


function showProgram(item, showBackButton) {
    this.$router.push('/personal-user-details-program?id=' +
        item.id +
        '&name='+this.getName(item)+
        '&showType='+ this.showType +
        '&enableFuture='+ this.enableFuture +
        '&hideTitle='+ this.hideTitle +
        '&showBackButton='+ showBackButton +
        '&programToken='+this.programToken)
}

function isDescriptionExpanded(item){
    if(item == null || item.id == null) return false;
    return this.expandedDescriptions[item.id] === true;
}

function toggleDescription(item){
    if(item == null || item.id == null) return;
    const current = this.expandedDescriptions[item.id] === true;
    this.$set(this.expandedDescriptions, item.id, !current);
}
//
// function addCompany() {
//     this.$router.push('/add-company-payment')
// }



// WEBPACK FOOTER //
// ./src/components/Personal/PersonalListProgramUser.js